<template>
  <a-layout class='index animated fadeIn s_bf'>
    <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='data'
     >
      <template v-slot:reason="{ record }">
        <div v-html='record.reason'></div>
      </template>
    </a-table>
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { getReleaseList } from "@/api/appletCode";
  import { $iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    is_release: 0,
    audit_status: 0,
    status: 1
  };
  export default {
    components: {  },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 1,
        active: 1,
        visible: false,
        activeKey: 0,
        columns: [{
          title: "版本号",
          dataIndex: "user_version",
          key: "user_version",
          width: 120,
        },
        {
          title: "APPID",
          dataIndex: "app_id",
          key: "app_id",
        },
        {
          title: "品牌商名称",
          dataIndex: "brand_name",
          key: "brand_name",
        },
        {
          title: "版本描述",
          dataIndex: "user_desc",
          key: "user_desc",
        },
        {
          title: "发布时间",
          dataIndex: "create_time",
          key: "create_time",
        },]
      });
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
  
      //小程序列表
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getReleaseList(values).then((res) => res.data);;
        state.listLoading = false;
        if ($iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        }

      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
      };
    },
  };
</script>